var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"icon-container"},[_c('div',{staticClass:"icon-contents"},[_c('Icon',{class:[`${_vm.type}-color`],attrs:{"name":_vm.icon_name}}),_vm._v(" "),_c('div',{staticClass:"icon-text"},[_vm._v("\n      "+_vm._s(_vm.text)+"\n    ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }